/* @flow */

import React from 'react';

import { style, merge } from 'glamor';


class Fixit extends React.Component {
  props: {
    transitionHeight: number,
    children: (isFixed: boolean, progress: number) => React.Element<*>,
  };

  state: {
    scrollY: number,
  };

  static defaultProps = {
    transitionHeight: 100,
  };

  constructor(props) {
    super(props);
    this.state = {scrollY: 0};
  }

  _handleScroll = () => {
    window.requestAnimationFrame(() => {
      this.setState({scrollY: window.scrollY});
    });
  };

  componentDidMount() {
    window.addEventListener('scroll', this._handleScroll);
    this._handleScroll();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this._handleScroll);
  }

  render() {
    const { children, transitionHeight } = this.props;
    const { scrollY } = this.state;

    const progress = scrollY > 0
      ? Math.min(1, scrollY / transitionHeight)
      : 0;

    const originalStyles = style({
      visibility: 'hidden',
      zIndex: -1,
      position: 'relative',
    });

    const cloneStyles = style({
      transform: 'translate3d(0,0,0)',
      zIndex: 10,
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
    });

    let styles;
    let isFixed;

    if (scrollY <= 0) {
      styles = cloneStyles;
      isFixed = false;
    } else {
      styles = merge(cloneStyles, style({
        position: 'fixed',
      }));
      isFixed = true;
    }

    return (
      <div>
        <div aria-hidden {...originalStyles}>{children(false, 0)}</div>
        <div {...styles}>{children(isFixed, progress)}</div>
      </div>
    );
  }
}

export default Fixit;



// WEBPACK FOOTER //
// ../src/client/components/Fixit.js